
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/company/privacy",
      function () {
        return require("private-next-pages/phone/company/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/company/privacy"])
      });
    }
  